import ToggleTalentActivationForm from './ToggleTalentActivationForm';

export default ToggleTalentActivationForm;
